import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConfigProvider } from "@/context/ConfigContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteLayout } from "@/components/site/SiteLayout";

import Home from "@/pages/Home";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import Experiences from "@/pages/Experiences";
import ExperienceDetail from "@/pages/ExperienceDetail";
import Itineraries from "@/pages/Itineraries";
import ItineraryDetail from "@/pages/ItineraryDetail";
import PartnerWithUs from "@/pages/PartnerWithUs";
import ServiceProviderRegistration from "@/pages/ServiceProviderRegistration";
import SendQuery from "@/pages/SendQuery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/admin/Login";
import AdminResetPassword from "@/pages/admin/ResetPassword";
import AdminDashboard from "@/pages/admin/Dashboard";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-cream font-accent text-charcoal">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ConfigProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/destinations" element={<Destinations />} />
                <Route path="/destinations/:slug" element={<DestinationDetail />} />
                <Route path="/experiences" element={<Experiences />} />
                <Route path="/experiences/:slug" element={<ExperienceDetail />} />
                <Route path="/itineraries" element={<Itineraries />} />
                <Route path="/itineraries/:slug" element={<ItineraryDetail />} />
                <Route path="/partner" element={<PartnerWithUs />} />
                <Route path="/service-provider-registration" element={<ServiceProviderRegistration />} />
                <Route path="/enquiry" element={<SendQuery />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
                <Route path="/terms-of-use" element={<LegalPage slug="terms-of-use" />} />
                <Route path="/disclaimer" element={<LegalPage slug="disclaimer" />} />
                <Route path="/payment-cancellation-policy" element={<LegalPage slug="payment-cancellation-policy" />} />
                <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
                <Route path="/terms" element={<Navigate to="/terms-of-use" replace />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/reset-password" element={<AdminResetPassword />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </ConfigProvider>
    </div>
  );
}

export default App;
